<template>
  <div v-click-outside="vcoConfig" class="relative-parent">
    <MapFiltersButton
      :class="{ 'is-open': popoverVisible }"
      @click="popoverVisible = !popoverVisible"
    />

    <MapFiltersPopover v-if="popoverVisible" />
  </div>
</template>

<script>
import MapFiltersButton from '@/components/map-filters/MapFiltersButton';
import MapFiltersPopover from '@/components/map-filters/MapFiltersPopover';

export default {
  components: {
    MapFiltersButton,
    MapFiltersPopover,
  },

  data() {
    return {
      popoverVisible: false,
    };
  },

  computed: {
    vcoConfig() {
      return {
        handler: this.hidePopover,
        events: ['mousedown'],
      };
    },
  },

  methods: {
    hidePopover() {
      this.popoverVisible = false;
    },
  },
};
</script>
